// footer-data.js

const footerData = {
    en: {
        contactHeading: 'Contact Us',
        ServicesHeading: 'Services',
        aboutHeading: 'About Us',
        hoursHeading: 'Office Hours',
        addressHeading: 'Service Area',
        menuHeading: 'Menu',

        menuHome: 'Home',
        menuServices: 'Services',
        menuAbout: 'About Us',
        menuGallery: 'Photo Gallery',
        menuReviews: 'Customer Reviews',
        menuContact: 'Contact Us',

        services: [
            { label: 'Dock Construction',              slug: 'dock-construction' },
            { label: 'Boat Lift Sales & Installation', slug: 'boat-lift-installation' },
            { label: 'Boat Lift Maintenance',          slug: 'boat-lift-maintenance' },
            { label: 'Boat Lift Repair',               slug: 'boat-lift-repair' },
            { label: 'Dock Repair',                    slug: 'dock-repair' },
            { label: 'Tiki Huts & Outdoor Structures', slug: 'tiki-huts' },
        ],

        privacyText: 'Privacy Policy',
        termsText: 'Terms & Conditions',

        licenseText: 'License #CBC1260600',
        tagline: 'Transforming Waterfront Dreams into Reality',
        copyrightText: 'Tropical Marine Construction of SWFL. All rights reserved.',
    },

    he: {
        contactHeading: 'Contact Us',
        ServicesHeading: 'Services',
        aboutHeading: 'About Us',
        hoursHeading: 'Office Hours',
        addressHeading: 'Service Area',
        menuHeading: 'Menu',

        menuHome: 'Home',
        menuServices: 'Services',
        menuAbout: 'About Us',
        menuGallery: 'Photo Gallery',
        menuReviews: 'Customer Reviews',
        menuContact: 'Contact Us',

        services: [
            { label: 'Dock Construction',              slug: 'dock-construction' },
            { label: 'Boat Lift Sales & Installation', slug: 'boat-lift-installation' },
            { label: 'Boat Lift Maintenance',          slug: 'boat-lift-maintenance' },
            { label: 'Boat Lift Repair',               slug: 'boat-lift-repair' },
            { label: 'Dock Repair',                    slug: 'dock-repair' },
            { label: 'Tiki Huts & Outdoor Structures', slug: 'tiki-huts' },
        ],

        privacyText: 'Privacy Policy',
        termsText: 'Terms & Conditions',

        licenseText: 'License #CBC1260600',
        tagline: 'Transforming Waterfront Dreams into Reality',
        copyrightText: 'Tropical Marine Construction of SWFL. All rights reserved.',
    },
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getFooterData(language) {
    const lang = resolveLanguage(language);
    return footerData[lang] || footerData.en;
}

export default footerData;
